'use strict';

(function() {
	angular.module('onboarding.broker.carriers')
		.directive('cobCarrierList', cobCarrierList);

	cobCarrierList.$inject = [
		'subjectObserverMessagesService', 'observerService', 'carrierService','sessionService', '$log', '$timeout',
		'$state', '$stateParams'
	];

	var subjectObserverMessagesService,
		observerService,
		carrierService,
		subjectMessages,
		observerMessages,
		sessionService,
		rowCount,
		reloadAjax,
		$log,
		$timeout,
		$state,
		$stateParams;

	function cobCarrierList(_subjectObserverMessagesService_,
		_observerService_,
		_carrierService_,
		_sessionService_,
		_$log_,
		_$timeout_,
		_$state_,
		_$stateParams_) {

		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierService = _carrierService_;
		sessionService = _sessionService_;
		$state = _$state_;
		$stateParams = _$stateParams_;
		rowCount = 100;

		reloadAjax = false;
		$log = _$log_;
		$timeout = _$timeout_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/broker/carriers/carrier-list.html',
			link: linkFunction
		};
	}

	function linkFunction(scope, elem) {

		activate();

		function activate() {
			scope.$stateParams = $stateParams;
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.m = {
				errors: []
			};

			scope.carriers = [];
			scope.sortType = 'lastVisited';
			scope.isSortDescending = true;
			scope.showConfirmation = false;
			scope.emailAddress = '';
			scope.ajaxIsRunning = false;
			scope.initialLoad = true;
			scope.showAllDocsList = false;

			scope.lastClicked = -1;
			scope.checkBoxClick = checkBoxClick;

			scope.associationEnumToString = associationEnumToString;
			scope.selectedCarriersCount = selectedCarriersCount;
			scope.saveNote = saveNote;
			scope.dismissErrors = dismissErrors;
			scope.carrierNoteHelper = carrierNoteHelper;
			scope.exportCarriers = exportCarriers;
			scope.exportCarriersDisable = exportCarriersDisable;
			scope.isWriteEnabledUser = sessionService.isAuthorizedBrokerWrite();
			scope.exportSelectedCarriersHelper = exportSelectedCarriersHelper;

			scope.closeModalWindow = closeModalWindow;
			scope.toggleDocsModal = toggleDocsModal;
			scope.getCarriers = getCarriers;
			scope.loadMore = loadMore;
			scope.setFilter = setFilter;
			scope.expandCarrier = expandCarrier;
			scope.changeStatus = changeStatus;
			scope.changeSort = changeSort;
			scope.getSortCssClass = getSortCssClass;
			scope.searchTypeChange = searchTypeChange;
			scope.searchInputChange = searchInputChange;
			scope.validateSearchInput = validateSearchInput;
			scope.searchClick = searchClick;
			scope.searchInputKeyPress = searchInputKeyPress;
			scope.notesClicked = notesClicked;
			scope.searchValue = '';
			resetOpenedCarrierIndex();
			resetCarrierProfileSectionStatusData();
			scope.getContractsInfo = getContractsInfo;

			scope.currentRow = 0;
			scope.totalRows = 0;
			scope.statusChoices = [
				{ id: -1, name: 'Export Selected to CSV' },
				//{ id: -2, name: 'Export Selected to XML' },
				{ id: 2, name: 'Mark as Incomplete' },
				{ id: 0, name: 'Mark as Complete' },
				{ id: 1, name: 'Hide Selected' },
				{ id: 5, name: 'Show Selected' }
			];

			scope.statuses = [
				{ id: 0, name: 'Complete' },
				{ id: 2, name: 'Incomplete' },
				{ id: 1, name: 'Hidden' }
			];

			registerEventHandlers();
			document.title = 'Carrier List';
			scope.searchType = 'company';

			searchTypeChange();
			// setFilter('complete');
		}

		function registerEventHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_SCROLL_MESSAGE, handler: loadMore }
				]);
		}

		function resetOpenedCarrierIndex() {
			scope.openedCarrierIndex = -1;
		}

		function dismissErrors() {
			scope.m.errors = [];
		}

		function carrierNoteHelper() {
			if (scope.carrier.notes === null) {
				return;
			}

			if (scope.carrier.notes.length > 20) {
				return scope.carrier.notes.substr(0, 20) + '...';
			}

			return scope.carrier.notes;
		}

		function changeStatus() {
			if (scope.selectedStatus !== null && scope.selectedStatus >= 0) {

				var changedItems = [];
				angular.forEach(scope.carriers,
					function(carrier) {
						if (carrier.checked) {

							var status = scope.selectedStatus;
							if (scope.selectedStatus === 5) {
								if (carrier.association === 1) {
									if (carrier.status === 'SIGNED') {
										status = 0;
									} else {
										status = 2;
									}
								} else {
									status = carrier.association;
								}
							} else {
								status = scope.selectedStatus;
							}

							if (carrier.association !== status) {
								var item = {
									carrierId: carrier.carrierId,
									status: associationEnumToString(status)
								};

								carrier.association = status;

								changedItems.push(item);
							}
						}
					});

				if (changedItems.length > 0) {
					carrierService.updateCarrierStatus(changedItems)
						.catch(function(e) {
							console.log(e);
						});
				}

				scope.selectedStatus = null;
			}

			if (scope.selectedStatus === -1) {
				exportCarriers();
			}

			scope.selectedStatus = null;
		}

		function checkBoxClick(event, index) {
			if (scope.lastClicked > -1 && event.shiftKey) {
				angular.forEach(scope.carriers.slice(Math.min(scope.lastClicked, index),
					Math.max(scope.lastClicked, index) + 1),
				function(carrier) {
					carrier.checked = scope.carriers[scope.lastClicked].checked;
				});
				document.getSelection().removeAllRanges();
			} else {
				scope.carriers[index].checked = !scope.carriers[index].checked;
			}
			scope.lastClicked = index;
			event.stopPropagation();
			event.preventDefault();
		}

		function exportAllCarriers() {
			scope.showConfirmation = true;

			carrierService.exportAllCarriers(scope.selectedFilter)
				.then(function(response) {
					scope.emailAddress = response.data.emailAddress;
				})
				.catch(function(e) {
					console.log(e);
				});
		}

		function exportSelectedCarriersHelper() {
			var params = '';

			angular.forEach(scope.carriers,
				function (carrier) {
					if (carrier.checked) {
						if (params) {
							params = params + ',';
						}
						params = params + carrier.carrierId;
					}
				});

			if ($stateParams.brokerId) {
				params = params + '&brokerId=' + $stateParams.brokerId;
			}

			return params;
		}

		function exportCarriers() {
			exportAllCarriers();
		}

		function exportCarriersDisable() {
			if (scope.carriers.length === 0) {
				return true;
			}
			if (selectedCarriersCount() === 0 && !scope.selectedFilter) {
				return true;
			}

			return false;
		}

		function changeSort(sortType) {
			scope.sortType = sortType;
			scope.isSortDescending = !scope.isSortDescending;
			scope.currentRow = 0;
			scope.totalRows = 0;
			scope.carriers = [];

			loadMore();
		}

		function getSortCssClass(sortType) {
			if (scope.sortType === sortType) {
				return scope.isSortDescending ? 'sort-dsc' : 'sort-asc';
			}
		}

		function setFilter(filter) {
			scope.initialLoad = false;
			scope.selectedFilter = filter;
			scope.currentRow = 0;
			scope.totalRows = 0;
			scope.carriers = [];
			scope.searchType = 'company';
			resetOpenedCarrierIndex();

			searchTypeChange();
			if (scope.ajaxIsRunning) {
				reloadAjax = true;
			}
			getCarriers();
		}

		function getCarriers() {
			if (scope.ajaxIsRunning) {
				return;
			}

			// Only execute if currentRow is less than total rows
			if (scope.currentRow === 0 || scope.currentRow < scope.totalRows) {
				scope.ajaxIsRunning = true;
				setTimeout(function() {
					observerService.sendMessageToSubject(scope,
						subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
				},
				1);

				carrierService.getCarriers(scope.selectedFilter,
					scope.currentRow,
					rowCount,
					scope.sortType,
					scope.isSortDescending,
					scope.currentRow === 0)
					.then(function(response) {
						if (scope.currentRow === 0) {
							scope.totalRows = response.data.totalRowsAvailable;
							setTimeout(function() { elem.find('.wrapper-table-flex')[0].scrollTop = 0; }, 1);
						}

						scope.currentRow += rowCount;
						var length = response.data.carriers.length;
						for (var i = 0; i < length; i++) {
							var carrier = response.data.carriers[i];
							carrier.selectedFilter = scope.selectedFilter;
							scope.carriers.push(carrier);
						}
					})
					.catch(function(e) {
						console.log(e);
						// alert('Unable to retrieve carriers');
					})
					.finally(function() {
						scope.ajaxIsRunning = false;
						observerService
							.sendMessageToSubject(scope,
								subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
						if (reloadAjax) {
							reloadAjax = false;
							scope.currentRow = 0;
							scope.totalRows = 0;
							scope.carriers = [];
							setTimeout(function() { getCarriers(); }, 1);
						}
					});
			}

			return;
		}

		function associationEnumToString(association) {
			var result = $.grep(scope.statuses,
				function(e) {
					return e.id === association;
				});

			if (result.length > 0) {
				return result[0].name;
			}

			return 'Unknown';
		}

		function saveNote(carrier) {
			if (carrier.oldValue !== carrier.notes || carrier.oldValue !== undefined) {
				if (carrier.notes !== '' && carrier.notes !== null) {
					carrierService.updateCarrierNote(carrier.carrierId, carrier.notes)
						.catch(function(res) {
							var modelErrors = res.data.modelState;
							var errors = [];
							for (var key in modelErrors) {
								for (var i = 0; i < modelErrors[key].length; i++) {
									errors.push(modelErrors[key][i]);
								}
							}

							observerService
								.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_GENERIC_SERVER_ERROR, errors);
							scope.m.errors = errors;
						});
				} else {
					if (carrier.oldValue !== '' && carrier.oldValue !== null) {
						carrierService.deleteCarrierNote(carrier.carrierId)
							.catch(function(res) {
								var modelErrors = res.data.modelState;
								var errors = [];
								for (var key in modelErrors) {
									for (var i = 0; i < modelErrors[key].length; i++) {
										errors.push(modelErrors[key][i]);
									}
								}

								observerService
									.sendMessageToSubject(scope,
										subjectMessages.COB_SUBJECT_GENERIC_SERVER_ERROR,
										errors);
								scope.m.errors = errors;
							});
					}
				}
			}
		}

		function loadMore() {
			if (scope.selectedFilter) {
				getCarriers();
			} else {
				searchCarriers();
			}
		}

		function closeModalWindow() {
			scope.showConfirmation = false;
		}

		function toggleDocsModal() {
			scope.showAllDocsList = !scope.showAllDocsList;
		}

		function expandCarrier(index) {
			if (scope.openedCarrierIndex >= 0) {
				scope.carriers[scope.openedCarrierIndex].isExpanded = false;
				if (index === scope.openedCarrierIndex) {
					resetOpenedCarrierIndex();

					return;
				}
				resetOpenedCarrierIndex();
			}
			var currentCarrier = scope.carriers[index];
			currentCarrier.isExpanded = true;
			scope.openedCarrierIndex = index;

			if (currentCarrier.isExpanded) {
				currentCarrier.documents = [];
				resetCarrierProfileSectionStatusData();
				carrierService.getCarrierPrimaryContact(currentCarrier.carrierId)
					.then(function(response) {
						currentCarrier.contactName = response.data.contactName;
						currentCarrier.contactRole = response.data.contactRole;
						currentCarrier.contactEmail = response.data.contactEmail;
						currentCarrier.contactPhone = response.data.contactPhone;
						currentCarrier.tinStatus = response.data.tinStatus;
						scope.carrierProfileSectionStatusData = createCarrierProfileSectionStatusData(response.data, response.data.signedContracts, currentCarrier.carrierId);
						currentCarrier.signedContracts = response.data.signedContracts;
						currentCarrier.documents =  response.data.documents;
					})
					.catch(function(response) {
						$log(response);
					});
			}
		}

		function resetCarrierProfileSectionStatusData() {
			scope.carrierProfileSectionStatusData = {};
		}

		function createCarrierProfileSectionStatusData(data, signedContracts, carrierId) {
			return {
				carrierProfileSectionsStatus: {
					companyInfoComplete: data.companyInfoComplete,
					contactsComplete: data.contactsComplete,
					equipmentInfoComplete: data.equipmentInfoComplete,
					laneInfoComplete: data.laneInfoComplete,
					taxInfoComplete: data.taxInfoComplete,
					documentsComplete: data.documentsComplete,
					insuranceInfoComplete: data.insuranceInfoComplete,
					contractsComplete: !!signedContracts
				},
				carrierId: carrierId
			};
		}

		function getContractsInfo(carrier) {
			if (carrier && carrier.signedContracts) {
				return carrier.signedContracts.signee + ', ' + carrier.signedContracts.title + ' (' + carrier.signedContracts.contracts.join(', ') + ')';
			}
		}

		function notesClicked($event, carrier) {
			$event.stopPropagation();
			if (!scope.isWriteEnabledUser) {
				carrier.editingNotes = false;
			} else if (carrier.editingNotes !== true) {
				carrier.oldValue = carrier.notes;
				carrier.editingNotes = true;
				if (carrier.oldValue !== carrier.notes || carrier.oldValue !== undefined) {
					if (scope.oldValue !== carrier.notes) {
						return;
					} else {
						carrierService.deleteCarrierNote(carrier.carrierId)
							.catch(function(res) {
								var modelErrors = res.data.modelState;
								var errors = [];
								for (var key in modelErrors) {
									for (var i = 0; i < modelErrors[key].length; i++) {
										errors.push(modelErrors[key][i]);
									}
								}

								observerService
									.sendMessageToSubject(scope,
										subjectMessages.COB_SUBJECT_GENERIC_SERVER_ERROR,
										errors);
								scope.m.errors = errors;
							});
					}
				}
			}
		}

		function searchTypeChange() {
			scope.searchValue = '';
			scope.searchValue2 = '';
			scope.searchInputError = '';
			switch (scope.searchType) {
			case 'company':
				scope.searchInputType = 'text';
				scope.searchInputPlaceholder = 'e.g. Sample Company';
				break;
			case 'dotNumber':
				scope.searchInputType = 'text';
				scope.searchInputPlaceholder = 'e.g. 1234567';
				break;
			case 'docketNumber':
				scope.searchInputType = 'text';
				scope.searchInputPlaceholder = 'e.g. 123456';
				break;
			case 'timeFrame':
				scope.searchInputType = 'text';
				scope.searchInputPlaceholder = 'e.g. mm/dd/yy';
				break;
			case 'intrastateNumber':
				scope.searchInputType = 'text';
				scope.searchInputPlaceholder = 'e.g. 001122333A';
				break;
			case 'scacCode':
				scope.searchInputType = 'text';
				scope.searchInputPlaceholder = 'e.g. ABCD';
				break;
			}
		}

		function validateSearchInput() {
			var errorText = 'Please input a valid search value';
			switch (scope.searchType) {
			case 'company':
				if (scope.searchValue.length > 155 || scope.searchValue.length === 0) {
					scope.searchInputError = errorText;
				} else {
					scope.searchInputError = '';
				}
				break;
			case 'dotNumber':
				if (/^[0-9]{1,9}$/.test(scope.searchValue)) {
					scope.searchInputError = '';
				} else {
					scope.searchInputError = errorText;
				}
				break;
			case 'docketNumber':
				if (/^[0-9]{1,9}$/.test(scope.searchValue)) {
					scope.searchInputError = '';
				} else {
					scope.searchInputError = errorText;
				}
				break;
			case 'timeFrame':
				if (!scope.searchValue && scope.searchValue2) {
					scope.searchValue = scope.searchValue2;
					scope.searchValue2 = '';
				}
				// eslint-disable-next-line no-useless-escape
				if (/^(0[1-9]|1[012])[\/](0[1-9]|[12][0-9]|3[01])[\/]\d\d$/.test(scope.searchValue)) {

					if (scope.searchValue2) {
						// eslint-disable-next-line no-useless-escape
						if (/^(0[1-9]|1[012])[\/](0[1-9]|[12][0-9]|3[01])[\/]\d\d$/.test(scope.searchValue2)) {
							scope.searchInputError = '';
							var searchValueParts = scope.searchValue.split('/');
							var searchValue2Parts = scope.searchValue2.split('/');

							var date1 = new Date(parseInt(searchValueParts[2]),
								parseInt(searchValueParts[0]) - 1,
								parseInt(searchValueParts[1]));
							var date2 = new Date(parseInt(searchValue2Parts[2]),
								parseInt(searchValue2Parts[0]) - 1,
								parseInt(searchValue2Parts[1]));
							if (date1 > date2) {
								var tempVal = scope.searchValue;
								scope.searchValue = scope.searchValue2;
								scope.searchValue2 = tempVal;
							}
						} else {
							scope.searchInputError = errorText;
						}
					} else {
						scope.searchValue2 = scope.searchValue;
					}

				} else {
					scope.searchInputError = errorText;
				}
				break;
			case 'intrastateNumber':
				if (/^[a-zA-Z0-9-]{1,15}$/.test(scope.searchValue)) {
					scope.searchInputError = '';
				} else {
					scope.searchInputError = errorText;
				}
				break;
			case 'scacCode':
				if (/^[a-zA-Z]{1,4}$/.test(scope.searchValue)) {
					scope.searchInputError = '';
				} else {
					scope.searchInputError = errorText;
				}
				break;
			}

			return !scope.searchInputError;
		}

		function selectedCarriersCount() {
			var count = 0;
			angular.forEach(scope.carriers,
				function(carrier) {
					count += carrier.checked ? 1 : 0;
				});

			return count;
		}

		function searchInputKeyPress(event) {
			var charCode = (event.which) ? event.which : event.keyCode;
			if (charCode === 13) { // on Enter
				searchClick();
				event.preventDefault();
				
				return;
			}
			switch (charCode) {
			case 8: //backspace
			case 35: //end
			case 36: //home
			case 37: //left arrow
			case 39: //right arrow
			case 46: //delete
				return;
			}

			var key = String.fromCharCode(charCode);

			switch (scope.searchType) {
			case 'company':
				break;
			case 'dotNumber':
			case 'docketNumber':
				if (!/^[0-9]$/.test(key)) {
					event.preventDefault();
				}
				break;
			case 'timeFrame':
				// TODO: move this to the date picker directive so it works with the picker
				// eslint-disable-next-line no-useless-escape
				if (!/^[0-9\/]$/.test(key)) {
					event.preventDefault();
				}
				break;
			case 'intrastateNumber':
				if (!/^[a-zA-Z0-9-]$/.test(key)) {
					event.preventDefault();
				}
				break;
			case 'scacCode':
				if (!/^[a-zA-Z]$/.test(key)) {
					event.preventDefault();
				}
				break;
			}
		}

		function searchInputChange() {
			switch (scope.searchType) {
			case 'company':
				scope.searchValue = scope.searchValue.substring(0, 50);
				break;
			case 'dotNumber':
				scope.searchValue = scope.searchValue.substring(0, 9);
				break;
			case 'docketNumber':
				scope.searchValue = scope.searchValue.substring(0, 9);
				break;
			case 'timeFrame':
				scope.searchValue = scope.searchValue.substring(0, 10);
				scope.searchValue2 = scope.searchValue2.substring(0, 10);
				break;
			case 'intrastateNumber':
				scope.searchValue = scope.searchValue.substring(0, 15);
				break;
			case 'scacCode':
				scope.searchValue = scope.searchValue.substring(0, 4);
				break;
			}
		}

		function searchClick() {
			if (validateSearchInput()) {
				scope.initialLoad = false;
				scope.currentRow = 0;
				scope.totalRows = 0;
				scope.carriers = [];
				scope.searchInputError = '';
				scope.selectedFilter = '';
				$timeout(function() {
					if (scope.ajaxIsRunning) {
						reloadAjax = true;
					}
					searchCarriers();
				}); // need to wait for $apply from date switch in validation
			}
		}

		function searchCarriers() {
			if (scope.ajaxIsRunning) {
				return;
			}

			// Only execute if currentRow is less than total rows
			if (scope.currentRow === 0 || scope.currentRow < scope.totalRows) {
				scope.ajaxIsRunning = true;
				observerService.sendMessageToSubject(scope,
					subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);

				carrierService.searchCarriers(scope.searchValue,
					scope.searchValue2,
					scope.searchType,
					scope.currentRow,
					rowCount,
					scope.sortType,
					scope.isSortDescending,
					scope.currentRow === 0)
					.then(function(response) {
						if (scope.currentRow === 0) {
							scope.totalRows = response.data.totalRowsAvailable;
							setTimeout(function() { elem.find('.wrapper-table-flex')[0].scrollTop = 0; }, 1);
						}

						scope.currentRow += rowCount;
						var length = response.data.carriers.length;
						for (var i = 0; i < length; i++) {
							var carrier = response.data.carriers[i];
							carrier.selectedFilter = scope.selectedFilter;
							scope.carriers.push(carrier);
						}
					})
					.catch(function(e) {
						console.log(e);
						// alert('Unable to retrieve carriers');
					})
					.finally(function() {
						scope.ajaxIsRunning = false;
						observerService
							.sendMessageToSubject(scope,
								subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
						if (reloadAjax) {
							reloadAjax = false;
							scope.currentRow = 0;
							scope.totalRows = 0;
							scope.carriers = [];
							searchCarriers();
						}
					});
			}

			return;
		}
	}
})();
